export const isFileVideo = (file: {type: string}) =>
  file.type.includes('video') && file.type !== 'video/vnd.dlna.mpeg-tts';
